import { render, staticRenderFns } from "./DabMJComponent.vue?vue&type=template&id=1ad9d245&scoped=true"
import script from "./DabMJComponent.vue?vue&type=script&lang=ts"
export * from "./DabMJComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad9d245",
  null
  
)

export default component.exports